/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ amount: NonNullable<unknown> }} Careers_Pay_Per_MonthInputs */



/**
* | output |
* | --- |
* | "{amount} per month" |
*
* @param {Careers_Pay_Per_MonthInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
export const careers_pay_per_month = /** @type {((inputs: Careers_Pay_Per_MonthInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Careers_Pay_Per_MonthInputs, { locale?: "en" | "zh" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return /** @type {LocalizedString} */ (`每月 ${i?.amount}`)
	return /** @type {LocalizedString} */ (`${i?.amount} per month`)
});